import * as React from "../../__compat__/react/main.entry.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { pickComponentCommonProps } from "../../interfaces/commonProps.mjs.mjs";
import { useLocale } from "../LocaleProvider/index.mjs.mjs";
import { StyledFormHelperText, StyledErrorIcon, StyledErrorIconPath, } from "./FormHelperText.styles.mjs.mjs";
const ErrorIcon = () => {
    const locale = useLocale();
    return (React.createElement(StyledErrorIcon, { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" },
        React.createElement("title", null, locale.formHelperText.errorIconTitle),
        React.createElement(StyledErrorIconPath, { d: "M21.5,20.5 L1.5,20.5 L11.5,2.5 L21.5,20.5 Z M11.5,16 L11.5,18 M11.5,8 L11.5,14" })));
};
export const FormHelperText = React.forwardRef(({ variant = 'hint', disabled = false, children, ...restProps }, ref) => {
    const showErrorIcon = variant === 'invalid';
    return (React.createElement(StyledFormHelperText, { variant: variant, disabled: disabled, ref: ref, ...pickComponentCommonProps(restProps), outerSpacing: useSpacing(restProps) },
        showErrorIcon && React.createElement(ErrorIcon, null),
        children));
});
FormHelperText.displayName = 'FormHelperText';
//# sourceMappingURL=FormHelperText.mjs.mjs.map